import React from 'react';
import './UserApps.css';

// 사용자 앱의 실제 연동 데이터 정의
const DUMMY_APPS = [
  {
    id: '1',
    name: '디지털선교사',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbxdYD0iia-bxSrC9Vw6dWf_tKJRn0j2qNdrYDbskylliHnKh9QXQ6d4aUQvaGPdz6AvxQ/exec',
  },
  {
    id: '2',
    name: '바이블가이드',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbwhhnjwqrA2THRcFn0DH26_Gz7KAyWWqG1XRhLNJD1_bZrrCbXkC3rNgomJwikHUx92/exec',
  },
  {
    id: '3',
    name: 'ADRA 긴급구호',
    iconUrl: '',
    url: 'https://script.google.com/macros/s/AKfycbzmjR41a5jeM-hkneZfe_33aoIswQOJUPTryEFHiM52FhUV5zkSMp9ESPXK8ZroMREs/exec',
  },
];

// 이니셜 아이콘을 위한 화사하고 조화로운 모던 그라데이션 색상 배열
const GRADIENTS = [
  'linear-gradient(135deg, #145351 0%, #236664 100%)', // 테마 청록색
  'linear-gradient(135deg, #2b5876 0%, #4e4376 100%)', // 딥 블루/퍼플
  'linear-gradient(135deg, #e65c00 0%, #f9d423 100%)', // 오렌지/옐로우
  'linear-gradient(135deg, #31b782 0%, #267c59 100%)', // 프레시 그린
  'linear-gradient(135deg, #8a2387 0%, #e94057 100%)', // 베리 핑크/레드
];

// 앱 ID에 따라 고유한 그라데이션 배경을 매핑해주는 함수
const getGradientStyle = (id) => {
  const index = parseInt(id, 10) || 0;
  return {
    background: GRADIENTS[(index - 1) % GRADIENTS.length],
  };
};

const UserApps = () => {
  return (
    <div className="user-apps-section">
      <div className="user-apps-title">바로가기 앱</div>
      <div className="user-apps-grid">
        {DUMMY_APPS.map((app) => (
          <a key={app.id} href={app.url} target="_blank" rel="noopener noreferrer" className="user-app-item">
            <div className="user-app-icon">
              {app.iconUrl ? (
                <img src={app.iconUrl} alt={app.name} className="user-app-icon-img" />
              ) : (
                <div className="user-app-placeholder-icon" style={getGradientStyle(app.id)}>
                  {app.name.charAt(0)}
                </div>
              )}
            </div>
            <span className="user-app-name">{app.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
};

export default UserApps;
